import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {GroupMember} from '../../graphql/groups.datatypes';
import {gqlRoomPartyMember} from '../GroupBookings/getGroupBooking.api';

interface GroupMemberData {
    groupMember: GroupMember
}

export const gqlGroupOptionDetails = `
    id
    mandatory
    resource_option_id
    group_id
    unit_cost
    editing_level
    view_level

    action_type
    unit_cost

    hidden_override
    additional_charge_override
    unit_cost_override
    action_type_override
`;

export const gqlGroupOptionOptionDetails = `
    id
    internal_name
    display_name
    description
`;

export const gqlGroupOptionOptionConditionsDetails = `
    id
    attribute
    attribute_value
`;

export const gqlGroupOptionOptionResourceDetails = `
    id
    allow_multiple
    internal_name
    display_name
    consumable
    allow_manual_overbooking
`;

export const gqlGroupOptionOptionResourceResourceBankDetails = `
    id
    remaining
    unit_price
`;

export const gqlGroupOptionRoomMemberOptionsDetails = `
    id
    unit_count
    unit_cost
`;

export const gqlGroupOptionRoomOptionsDetails = `
    id
    unit_count
    unit_cost
`;

export const gqlGroupOption = `
    ${gqlGroupOptionDetails}

    option {
        ${gqlGroupOptionOptionDetails}

        conditions {
            ${gqlGroupOptionOptionConditionsDetails}
        }

        resource {
            ${gqlGroupOptionOptionResourceDetails}

            resource_banks {
                ${gqlGroupOptionOptionResourceResourceBankDetails}
            }
        }
    }

    roomMemberOptions {
        ${gqlGroupOptionRoomMemberOptionsDetails}
    }

    roomOptions {
        ${gqlGroupOptionRoomMemberOptionsDetails}
    }
`;

export const gqlGroupMember = `
    id
    group_id
    user_id
    first_name
    last_name
    email
    cellphone_code
    cellphone
    dob
    group_role
    tour_role
    validated
    cancelled
    disabled
    authorised
    ageAtEvent

    group {
      id
      name
      editing_level
      tour_resource_id
      booking_form_url
      end_date

      options {
        ${gqlGroupOption}
      }
    }

    user {
      id
      email
    }

    roomMember {
        ${gqlRoomPartyMember}
    }

    adjustments {
        id
        adjustment_type
        amount
        description
    }

    documents {
        id
    }

    groupMemberPayments {
        id
        amount

        payment {
            id
            timestamp

            billingPartyMember {
                id
                first_name
                last_name
                billing_party_id
            }
        }
    }
`;

export const GET_GROUP_MEMBER_QUERY = gql`
    query getGroupMember($id: Int!){
        groupMember(id: $id){
          ${gqlGroupMember}
        }
    }
`;

export const getGroupMember = (groupMemberId: number | null) => {
  const id = groupMemberId ? groupMemberId : -1;
  return useQuery<GroupMemberData>(
    GET_GROUP_MEMBER_QUERY,
    {
      variables: {id}
    }
  );
};

export default getGroupMember;
